export type HiddenMechanic = {
  isMechanicHidden: boolean;
};
